//chapter1
export default {
    id : 9,//chapter number
    title : '09. SBA(Solder Ball Attach) 공정 (3)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/09/videos/a09.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '솔더의 종류',
                '플럭스 크리닝',
            ],
            body2 : [
                '솔더의 종류에 대해 설명할 수 있다.',
                '플럭스 크리닝에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/09/videos/09.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '솔더 볼은 납 성분이 없는 Lead Free 솔더 볼을 사용하며 Sn, Ag, Cu가 주성분으로 구성된다.',//html available
                    answer : "1",
                    explain : '환경오염을 발생시킬 수 있는 납 성분은 솔더 볼에 사용하지 않는다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : 'SAC305 솔더는 3.0% silver와 0.5% copper, 나머지는 Sn 성분을 의미한다.',//html available
                    answer : "1",
                    explain : 'SAC305, SAC105, SAC0307 등의 용어를 사용하여 솔더의 성분과 함량을 표시한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>솔더의 종류<br>
                        - 환경 문제로 인해 Pb가 포함된 솔더의 사용 자제<br>
                        - 납이 없는 Tin-silver-copper(Sn-Ag-Cu, SAC) 사용 추세<br>
                        - SAC 솔더는 적절한 피로 특성, 강도, 솔더의 젖음성을 갖추고 있는 것으로 평가</li>
                    </ul>`
                },
                {
                    body : `<ul>
                        <li>플럭스 크리닝<br>
                        - 솔더 볼 접합 공정이 완료된 후 플럭스를 크리닝 함<br>
                        - 플럭스가 전기적으로 쇼트를 발생시킬 수 있음<br>
                        - 크리닝은 DI(De-ionized) 워터를 이용해서 진행함<br>
                        - 플럭스는 PCB와 솔더 사이 발생할 수 있는 산화물을 제거해서 접합 강도를 좋게하고 전기적 특성을 향상시키는 역할을 함</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/09/videos/a09.mp4',
        },
    ]
}